



































































import { Component, Prop, Vue } from 'vue-property-decorator'
import DateClass from '@/app/module/date'

@Component
export default class AiAdviceList extends Vue {
  @Prop() private data!: any

  private dateToStringYmd (date: any) {
    if (date !== '' && date !== null && date !== undefined) {
      const updateDate = new Date(date)
      return DateClass.dateToStringYmd(updateDate, '年月日')
    }
  }
}

